export default "__VITE_ASSET__CcM3gLL2__"